/**
 * @generated SignedSource<<978cbd182e38f119026a071a88592129>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type LicenseProductDataContentKind = "CertificationContent" | "CourseContent" | "CourseWithCertificationContent";
import { FragmentRefs } from "relay-runtime";
export type ProductTypeColumn_ProductFragment$data = {
  readonly data: {
    readonly content?: {
      readonly kind: LicenseProductDataContentKind;
    } | null;
  };
  readonly " $fragmentType": "ProductTypeColumn_ProductFragment";
};
export type ProductTypeColumn_ProductFragment$key = {
  readonly " $data"?: ProductTypeColumn_ProductFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductTypeColumn_ProductFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductTypeColumn_ProductFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "data",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "content",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "LicenseProductData",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "e2797661d75f759cdd4ae8f1697ab1d7";

export default node;
